import { api } from '@xstudios/xapp-auth/services/authService'

export async function getJob(jobId) {
  const { data } = await api.get(`jobs/${encodeURIComponent(jobId)}`)
  return data
}

export async function streamJobEvents(jobId, token, handlers = {}) {
  const {
    onError = () => {},
    onEvent = () => {},
    onOpen = () => {},
    signal,
  } = handlers

  const url = `/api/jobs/${encodeURIComponent(jobId)}/events`
  const response = await fetch(url, {
    headers: {
      Accept: 'text/event-stream',
      Authorization: `Bearer ${token}`,
    },
    method: 'GET',
    signal,
  })

  if (!response.ok || !response.body) {
    throw new Error(`Event stream failed: HTTP ${response.status}`)
  }

  onOpen()
  const decoder = new TextDecoder()
  const reader = response.body.getReader()
  let buffer = ''

  while (true) {
    const { done, value } = await reader.read()
    if (done) {
      break
    }
    buffer += decoder.decode(value, { stream: true })

    let boundaryIndex = buffer.indexOf('\n\n')
    while (boundaryIndex >= 0) {
      const frame = buffer.slice(0, boundaryIndex)
      buffer = buffer.slice(boundaryIndex + 2)
      if (frame.trim()) {
        try {
          onEvent(parseSseChunk(frame))
        } catch (error) {
          onError(error)
        }
      }
      boundaryIndex = buffer.indexOf('\n\n')
    }
  }
}

function parseSseChunk(chunkText) {
  const lines = String(chunkText || '').split('\n')
  let id = ''
  let event = 'message'
  const dataLines = []

  for (const line of lines) {
    if (!line || line.startsWith(':')) {
      continue
    }
    if (line.startsWith('id:')) {
      id = line.slice(3).trim()
    } else if (line.startsWith('event:')) {
      event = line.slice(6).trim() || 'message'
    } else if (line.startsWith('data:')) {
      dataLines.push(line.slice(5).trim())
    }
  }

  const rawData = dataLines.join('\n').trim()
  let data = rawData
  try {
    data = rawData ? JSON.parse(rawData) : null
  } catch {
    data = rawData
  }
  return { data, event, id }
}
